
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search.php",
      function () {
        return require("private-next-pages/search.php.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search.php"])
      });
    }
  